import { MissingDesignItemInformationDTO, MissingOfferDriverStatusDTO, OKDriverStatusDTO } from '@luminovo/http-client';

export type CalculationWarning = OKDriverStatusDTO | MissingDesignItemInformationDTO | MissingOfferDriverStatusDTO;

export const isMissingDesignItemInformation = (status: CalculationWarning): status is MissingDesignItemInformationDTO =>
    status.type === 'MissingDesignItemInformation';

export const isMissingOffer = (status: CalculationWarning): status is MissingOfferDriverStatusDTO =>
    status.type === 'MissingOffer';
